import { Reveal } from "@/components/site/Reveal";

const weekday = (h) => (h >= 2 && h < 5 ? "closed" : h >= 15 && h < 22 ? "peak" : "both");
const weekend = (h) => (h < 7 ? "closed" : "both");
const COLORS = { both: "bg-[var(--gold)]", peak: "bg-[#C88A35]/30 stripe-bg border border-[#C88A35]/60", closed: "bg-white/[0.04]" };
const TICKS = ["12A", "3A", "6A", "9A", "12P", "3P", "6P", "9P", "12A"];

function Row({ label, fn, testid }) {
  return (
    <div className="space-y-2" data-testid={testid}>
      <p className="font-display text-lg font-bold uppercase tracking-wide text-white">{label}</p>
      <div className="flex h-12 gap-[2px] overflow-hidden rounded-sm">
        {Array.from({ length: 24 }, (_, h) => (
          <div key={h} className={`flex-1 ${COLORS[fn(h)]}`} title={`${h}:00`} />
        ))}
      </div>
      <div className="flex justify-between font-mono-ui text-[10px] text-white/40">
        {TICKS.map((t, i) => <span key={i}>{t}</span>)}
      </div>
    </div>
  );
}

function Legend({ cls, title, text }) {
  return (
    <div className="flex items-start gap-3">
      <span className={`mt-1 h-4 w-8 shrink-0 rounded-sm ${cls}`} />
      <div><p className="font-display text-base font-bold uppercase text-white">{title}</p><p className="text-xs text-white/55">{text}</p></div>
    </div>
  );
}

export function PeakChart() {
  return (
    <Reveal>
      <div className="rounded-md border border-white/10 bg-[#111] p-5 sm:p-8" data-testid="peak-offpeak-chart">
        <div className="mb-8 flex flex-col justify-between gap-2 sm:flex-row sm:items-end">
          <div>
            <p className="eyebrow">Peak vs Off-Peak</p>
            <h3 className="h-display mt-2 text-3xl text-white sm:text-4xl">When can you train?</h3>
          </div>
          <p className="max-w-sm text-sm text-white/55">Off-Peak covers everything except weekdays 3 PM – 10 PM. Peak covers every open hour.</p>
        </div>
        <div className="space-y-6">
          <Row label="Monday – Friday" fn={weekday} testid="peak-chart-weekday" />
          <Row label="Saturday & Sunday" fn={weekend} testid="peak-chart-weekend" />
        </div>
        <div className="mt-8 grid gap-4 border-t border-white/10 pt-6 sm:grid-cols-3">
          <Legend cls={COLORS.both} title="Off-Peak + Peak" text="Weekdays 5 AM – 3 PM & 10 PM – 2 AM. All weekend." />
          <Legend cls={COLORS.peak} title="Peak only" text="Weekdays 3 PM – 10 PM, the after-work rush." />
          <Legend cls={`${COLORS.closed} border border-white/10`} title="Closed" text="Weekdays 2 – 5 AM. Weekends midnight – 7 AM." />
        </div>
      </div>
    </Reveal>
  );
}
